import { gql } from "@apollo/client";

export const GET_SAVED_CLIPS = gql`
  query GetSavedClips(
    $userId: String!
    $sort: ClipSort
    $after: String
    $statuses: [ClipStatus!]
    $saved: Boolean
  ) {
    profile(query: $userId) {
      savedClipsCount
      clips(
        saved: $saved
        first: 20
        after: $after
        sort: $sort
        statuses: $statuses
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          internalId
          title
          game
          tags {
            key
            value
          }
          thumbnailUrl(style: STANDARD)
          views
          score
          createdAt
          saved {
            savedAt
          }
          developer {
            id
            name
          }
          expires {
            expiresAt
            reason
          }
        }
      }
    }
  }
`;
